var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"today-button-section"},[_c('NcButton',{staticClass:"button",attrs:{"aria-label":_vm.title,"title":_vm.title},on:{"click":function($event){return _vm.today()}}},[_vm._v("\n\t\t"+_vm._s(_vm.$t('calendar', 'Today'))+"\n\t")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }